import React, { useEffect, useRef } from 'react';

const ScrollingText = ({ children, className = '', style = {} }) => {
  const ref = useRef();

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const span = el.querySelector('span');
    if (!span) return;

    // Delay until next frame to ensure DOM is painted
    requestAnimationFrame(() => {
      const containerWidth = el.offsetWidth;
      const contentWidth = span.scrollWidth;

      if (contentWidth > containerWidth) {
        const distance = contentWidth;
        const speed = 50; // pixels per second
        const duration = (distance / speed).toFixed(2);

        span.style.setProperty('--scroll-distance', `${distance}px`);
        span.style.setProperty('--scroll-duration', `${duration}s`);
        el.classList.add('scroll-on-hover-enabled');
      } else {
        el.classList.remove('scroll-on-hover-enabled');
      }
    });
  }, [children]); // rerun if text changes

  return (
    <span
      ref={ref}
      className={`scroll-on-hover ${className}`}
      style={{
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
        minWidth: 0,
        display: 'block',
        position: 'relative',
        ...style
      }}
    >
      <span
        style={{
          display: 'inline-block',
          paddingRight: '1rem',
          whiteSpace: 'nowrap',
        }}
      >
        {children}
      </span>
    </span>
  );
};

export default ScrollingText; // 👈 This makes it usable in other files